import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import Common from "../based/Common";
import { INITPAGING, NOTIFY, PLATFORM } from "../based/Constants";
import { SwichToogle } from "../based/inputs/SwitchToogle";
import TextNumber from "../based/inputs/TextNumber";
import { Notify } from "../based/Notify";
import TFUSelect from "../based/refactor/TFUSelect";
import PlatformServices from "../based/services/PlatformServices";
import PushingServices from "../based/services/PushingServices";
import Breadcum from "../layout/refactor/Breadcum/Breadcum";
import Lazada from "./assets/Lazada.png";
import PercentageIcon from "./assets/PercentageIcon.svg";
import Shopee from "./assets/Shopee.png";
import Tiktok from "./assets/Tiktok.png";
import CostModal from "./CostModal";
import PlatformProductModal from "./PlatformProductModal";
import PushTemplateModal, { TemplateType } from "./PushTemplateModal";

const PackageType = {
    TShirt: 1,
    Case: 2,
    Bottle: 3,
    Pencase: 4,
    Sticker: 5,
};

const Artwork_Type = {
    Front: 1,
    Back: 2,
};

const CostDiscountType = {
    Fixed: 0,
    Voucher: 1,
    Marketing: 2,
    Other: 3,
};

const PushingProductMultiPlatformModel = {
    appCategoryId: 0,
    opfCategoryId: 0,
    platform: PLATFORM.Shopee,
    platformName: "",
    photoshopId: 0,
    platformBreadcrumb: "",
    photoshopFiles: [],
    photoshopProducts: [],
    shopOptions: [],
    shopId: "",
    listOPFCategory: [],
};

const FileType = {
    Normal: 0,
    Case: 1,
};

const PushingProductMultiModel = {
    id: 0,
    pushingProductId: 0,
    name: "",
    categoryId: 0,
    platformCategoryId: 0,
    platformBreadcrumb: "",
    brand: "Ranus",
    content: "",
    length: 0,
    width: 0,
    height: 0,
    weight: 0,
    printType: 0,
    photoshopId: 0,
    colorCode: "",
    colorName: "",
    appProductVariantId: "",
    platform: PLATFORM.Undefined,
    shopId: "",
    pushingProduct: {},
    pushingPhotoshopProducts: [],
    artworkType: Artwork_Type.Front,
    artworkCount: 1,
    multiPlatformModels: [PushingProductMultiPlatformModel],
    designId: 0,
    avatar: "",
    fileType: FileType.Normal,
    shopSetModels: [],
    packageType: 0,
};

function PushingMultiDetail(props) {
    const { designId } = props.match.params;
    const [model, setModel] = useState(PushingProductMultiModel);
    const history = useHistory();
    const [showTemplateModal, setShowTemplateModal] = useState(false);
    const [templateType, setTemplateType] = useState(0);
    const [listProductNameTemplate, setListProductNameTemplate] = useState([]);
    const [listProductContentTemplate, setListProductContentTemplate] = useState([]);
    const [isBusy, setIsBusy] = useState(false);
    const location = useLocation();
    const [showCostModal, setShowCostModal] = useState(false);
    const [manualModal, setManualModal] = useState(false);

    useEffect(() => {
        if (designId) {
            _getProductCustomizeMultiById(designId);
        }
    }, [designId]);

    useEffect(() => {
        if (!showTemplateModal) {
            getListProductNameTemplate();
            getListProductContentTemplate();
        }
    }, [showTemplateModal]);

    const getListProductNameTemplate = async () => {
        let [err, data] = await PlatformServices.GetTemplateDTOs({ ...INITPAGING, pageNumber: 1, pageSize: 100, type: TemplateType.ProductName });
        if (!err && data) {
            setListProductNameTemplate(data.listObjects);
        }
    };

    const getListProductContentTemplate = async () => {
        let [err, data] = await PlatformServices.GetTemplateDTOs({ ...INITPAGING, pageNumber: 1, pageSize: 100, type: TemplateType.ProductContent });
        if (!err && data) {
            setListProductContentTemplate(data.listObjects);
        }
    };

    const checkedPlatform = useMemo(() => {
        let md = { ...model };
        let platforms = md.multiPlatformModels;
        if (!platforms || platforms.length == 0) return null;
        let platform = platforms.find((x) => x.isActive);
        return platform;
    }, [model]);

    const checkedShop = useMemo(() => {
        let md = { ...model };
        if (!md || !md.multiPlatformModels || md.multiPlatformModels.length == 0) return null;
        let platforms = md.multiPlatformModels;
        for (var pl of platforms) {
            var shopOptions = pl.shopOptions;
            for (var shop of shopOptions) {
                if (shop.isActive) {
                    shop.platform = pl.platform;

                    //lấy danh sách ngành hàng
                    if (shop.listOPFCategory && shop.listOPFCategory.length > 0) {
                        const listCat = shop.listOPFCategory.map((x) => {
                            return {
                                value: x.opfCategoryId,
                                label: x.platformBreadcrumb,
                            };
                        });
                        shop.listCat = listCat;
                    }

                    //lấy ds thương hiệu
                    if (shop.partnerPlatformBrands && shop.partnerPlatformBrands.length > 0) {
                        const listBrand = shop.partnerPlatformBrands.map((x) => {
                            return {
                                value: x.brandId,
                                label: x.brandName,
                            };
                        });
                        shop.listBrand = listBrand;
                    }

                    //lấy danh sách danh mục
                    const listShopCat = shop.listShopCatOption.map((x) => {
                        return {
                            value: x.id,
                            label: x.name,
                        };
                    });
                    shop.listShopCat = listShopCat;
                    return shop;
                }
            }
        }

        return null;
    }, [model]);

    async function _getProductCustomizeMultiById(designId) {
        let [err, data] = await PushingServices.GetProductCustomizesMultiById(designId);
        if (!err && data) {
            setModel(data);
        } else {
            setModel(null);
            Notify(NOTIFY.ERROR, "Lỗi", err.message);
        }
    }

    //lấy thông tin sản phẩm theo photoshopId
    async function _getPhotoshopProduct(md) {
        let [err, data] = await PushingServices.GetPushingPhotoshopProductDetail(md);
        if (!err && data) {
            data = data.map((item) => {
                item.checked = true;
                return item;
            });
            return data;
        } else {
            return [];
        }
    }

    async function createUpdatePushProduct() {
        let md = { ...model };
        md.designId = +designId;
        md.multiPlatformModels = md.multiPlatformModels.filter((x) => x.shopOptions.some((y) => y.isChecked && y.photoshopProducts != null && y.photoshopProducts.length > 0));

        if (!md.multiPlatformModels || md.multiPlatformModels.length == 0) {
            Notify(NOTIFY.ERROR, "Lỗi", "Vui lòng chọn shop muốn đẩy");
            return;
        }

        if (md.multiPlatformModels && md.multiPlatformModels.length > 0) {
            for (var multi of md.multiPlatformModels) {
                multi.shopOptions = multi.shopOptions.filter((x) => x.isChecked);
                if (multi.shopOptions && multi.shopOptions.length > 0) {
                    for (var shop of multi.shopOptions) {
                        shop.photoshopProducts = shop.photoshopProducts.filter((x) => x.checked && x.partnerSellPrice > 0);

                        if (shop.photoshopProducts) {
                            for (var psProduct of shop.photoshopProducts) {
                                let variants = psProduct.pushingPhotoshopVariants;

                                if (variants && variants.length > 0) {
                                    for (var variant of variants) {
                                        variant.sellPrice = psProduct.sellPrice;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        let [err, data] = await PushingServices.CreateUpdatePushProductMulti(md);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Đẩy sản phẩm thành công, hệ thống sẽ tự động cập nhật sản phẩm sau ít phút");
            setTimeout(() => {
                history.push("/pushing-manage");
            }, 1000);
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", err.message);
        }
    }

    async function applyToAllShop() {
        setIsBusy(true);

        //lấy ra shop đang được active
        let standardShop = {};
        let md = { ...model };
        let platforms = md.multiPlatformModels;
        for (var platform of platforms) {
            var shopOptions = platform.shopOptions;
            for (var shop of shopOptions) {
                if (shop.isActive) {
                    //shop đang được active
                    standardShop = shop;

                    break;
                }
            }
        }

        if (!standardShop) {
            setIsBusy(false);
            Notify(NOTIFY.ERROR, "Lỗi", "Đồng bộ không thành công");
            return;
        }

        //lấy ra sản phẩm đang được lấy avatar/và sản phẩm đang checked
        let standardAvatarCheckedId = 0;
        let standardProductChecked = [];
        let photoshopProducts = standardShop.photoshopProducts;
        for (const photoshopProduct of photoshopProducts) {
            if (photoshopProduct.checked) {
                standardProductChecked.push(photoshopProduct.id);
                if (photoshopProduct.avatarChecked) {
                    standardAvatarCheckedId = photoshopProduct.id;
                }
            }
        }

        //lấy ra standard photoshopId
        let standardPhotoshopId = standardShop.photoshopId;

        //lấy ra standard artworktype
        let standardArtworkType = standardShop.artworkType;

        //bắt đầu duyệt lại từng platform, điều chỉnh thông tin cho từng shop, đang được checked
        for (var platform of platforms) {
            var shopOptions = platform.shopOptions;
            var photoshopFiles = platform.photoshopFiles;
            if (!photoshopFiles || photoshopFiles.length == 0) continue;
            var anyStandardShopId = photoshopFiles && photoshopFiles.some((x) => x.id == standardPhotoshopId); //kiểm tra có chung file pts hay không
            for (var shop of shopOptions) {
                //apply các artworktype như nhau
                shop.artworkType = standardArtworkType;

                //tự động apply các file pts giống nhau
                if (anyStandardShopId) {
                    shop.photoshopId = standardPhotoshopId;

                    //lấy ra thông tin sản phẩm theo photoshopId
                    if (md.packageType != PackageType.Case) {
                        let pushModel = {
                            designId: designId,
                            photoshopId: standardPhotoshopId,
                            platform: platform.platform,
                            shopId: shop.value,
                        };
                        let psProducts = [];
                        psProducts = await _getPhotoshopProduct(pushModel);
                        if (!psProducts || psProducts.length == 0) continue;

                        //uncheck những sản phẩm không được chọn
                        for (var psProduct of psProducts) {
                            if (!standardProductChecked.includes(psProduct.id)) {
                                psProduct.checked = false;
                            }
                        }

                        let indexStandardAvatarChecked = psProducts.findIndex((x) => x.id == standardAvatarCheckedId && x.checked);
                        if (indexStandardAvatarChecked >= 0) {
                            psProducts[indexStandardAvatarChecked].avatarChecked = true;
                        } else {
                            let checkedItem = psProducts.find((x) => x.checked);
                            checkedItem.avatarChecked = true;
                        }
                        shop.photoshopProducts = psProducts;
                    }
                }
            }
        }

        setModel({ ...model });
        setIsBusy(false);
        Notify(NOTIFY.SUCCESS, "Thành công", "Áp dụng thành công");
    }

    function getImage(platform) {
        switch (platform) {
            case PLATFORM.Shopee:
                return <img src={Shopee} />;
            case PLATFORM.Lazada:
                return <img src={Lazada} />;
            case PLATFORM.Tiktok:
                return <img src={Tiktok} />;
            default:
                return "";
        }
    }

    function reApplyCost(fleFixCost) {
        const flexibleDiscountCost = fleFixCost.flexibleDiscountCost;
        const fixedDiscountCost = fleFixCost.fixedDiscountCost;
        let md = { ...model };
        md.multiPlatformModels.forEach((x) => {
            x.shopOptions.forEach((y) => {
                y.photoshopProducts.forEach((pp) => {
                    pp.flexibleCostDiscount = flexibleDiscountCost;
                    pp.fixedCostDiscount = fixedDiscountCost;

                    //chi phí sản xuất ranus
                    var sumProduction =
                        pp.partnerProductCost + //giá phôi
                            pp.partnerPrintCost + //chi phí in
                            pp.fixedCostDiscount?.logoPartnerCost + //chi phí logo
                            pp.fixedCostDiscount?.packageCost + //chi phí đóng gói
                            pp.fixedCostDiscount?.boxCost + //chi phí hộp
                            pp.fixedCostDiscount?.deliverToPostOfficeCost ?? 0; //giao ra bưu cục

                    pp.productionCost = sumProduction + sumProduction * (pp.fixedCostDiscount?.baseCostVAT / 100 || 0) + sumProduction * (pp.fixedCostDiscount?.baseCostCIT / 100 || 0);

                    //thuế partner
                    pp.partnerTaxCost = (pp.sellPrice * pp.fixedCostDiscount.vat) / 100 + (pp.sellPrice * pp.fixedCostDiscount.personalTax) / 100;

                    //loop từng loại phí của tiktok
                    var listPartnerCostDiscount = [];
                    //loop từng discount type
                    for (var eType of Object.values(CostDiscountType)) {
                        var fleType = flexibleDiscountCost.filter((x) => x.discountType == eType);
                        if (fleType == null || fleType.length == 0) continue;
                        var element = {
                            discountType: eType,
                            discountTotal: 0,
                        };
                        fleType.forEach((fle) => {
                            var discount = (pp.sellPrice * fle.shopValue) / 100;
                            element.discountTotal += discount > fle.shopMaximum && fle.shopMaximum > 0 ? fle.shopMaximum : discount;
                        });
                        listPartnerCostDiscount.push(element);
                    }
                    pp.listPartnerCostDiscount = listPartnerCostDiscount;

                    //tổng chi phí
                    pp.total = pp.productionCost + pp.partnerTaxCost + pp.listPartnerCostDiscount.reduce((acc, x) => acc + x.discountTotal, 0);
                    //lợi nhuận
                    pp.grossProfit = pp.sellPrice - pp.total;
                    pp.grossProfitPercentage = (pp.grossProfit / pp.sellPrice) * 100;
                });
            });
        });
        setModel({ ...md });
    }

    if (!model) return <div>Hiện tại không có dữ liệu</div>;
    return (
        <React.Fragment>
            <Breadcum
                options={[
                    {
                        value: "/",
                        label: "Trang chủ",
                    },
                    {
                        value: "/pushing-manage",
                        label: "Đẩy sản phẩm",
                    },
                    {
                        value: location.pathname,
                        label: "Chi tiết đẩy sản phẩm",
                    },
                ]}
                title={"Chi tiết đẩy sản phẩm"}
            />
            <Wrapper>
                <section className="product_overview">
                    <div className="avatar">
                        <img src={model.avatar} alt={model.name} />
                    </div>
                    <div className="overview-section">
                        <div className="overview-title">{model.designName}</div>
                        <div className="overview-color">Màu {model.colorName}</div>
                    </div>
                </section>

                <section className="product_info">
                    {/* <h6>THÔNG TIN SẢN PHẨM</h6> */}
                    <div className="product_info-body">
                        <div className="info-row">
                            <label htmlFor="" className="required">
                                Tên sản phẩm
                            </label>
                            <div className="info-input">
                                <div className="template">
                                    <div className="list-tag">
                                        {listProductNameTemplate &&
                                            listProductNameTemplate.length > 0 &&
                                            listProductNameTemplate.map((item, index) => {
                                                return (
                                                    <div
                                                        className="tag cursor-pointer"
                                                        key={index}
                                                        onClick={(e) => {
                                                            let content = item.content;

                                                            //replace SET_TITLE
                                                            content = content.replace("SET_TITLE", model.designName);
                                                            setModel({ ...model, name: content });
                                                        }}
                                                    >
                                                        {item.title}
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                                <div className="input-area">
                                    <input
                                        type="text"
                                        value={model.name}
                                        onChange={(e) => {
                                            let length = e.target.value.length;
                                            let name = model.name;
                                            if (length < name.length) {
                                                setModel({ ...model, name: e.target.value });
                                            } else {
                                                if (length > 120) return;
                                                setModel({ ...model, name: e.target.value });
                                            }
                                        }}
                                    />
                                    <span className="suffix">{model && model.name ? model.name.length : 0}/120</span>
                                </div>
                            </div>
                        </div>
                        {/* <div className="info-row">
                            <label htmlFor="" className="required">
                                Thương hiệu
                            </label>
                            <div className="info-input">
                                <div className="input-area">
                                    <input type="text" value={`Ranus`} readOnly className="disabled" />
                                </div>
                            </div>
                        </div> */}
                        <div className="info-row">
                            <label htmlFor="" className="required">
                                Mô tả thiết kế
                            </label>
                            <div className="info-input">
                                <div className="template">
                                    <div className="list-tag">
                                        {listProductContentTemplate &&
                                            listProductContentTemplate.length > 0 &&
                                            listProductContentTemplate.map((item, index) => {
                                                return (
                                                    <div
                                                        className="tag cursor-pointer"
                                                        key={index}
                                                        onClick={(e) => {
                                                            let content = item.content;
                                                            content = content.replace("SET_TITLE", model.designName);
                                                            setModel({ ...model, content: content });
                                                        }}
                                                    >
                                                        {item.title}
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                                <div className="input-area">
                                    <textarea
                                        rows={5}
                                        type="text"
                                        value={model.content}
                                        onChange={(e) => {
                                            setModel({ ...model, content: e.target.value });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="push_product">
                    <section className="push_shop">
                        <h6>Chọn shop muốn đẩy</h6>
                        {model.multiPlatformModels &&
                            model.multiPlatformModels.map((item, index) => {
                                if (!item.shopOptions || item.shopOptions.length == 0) return "";
                                return (
                                    <div className="shop-platform" key={index}>
                                        <div className="heading">
                                            <div className="icon">{getImage(item.platform)}</div>
                                        </div>
                                        <div className="list-shop">
                                            {item.shopOptions &&
                                                item.shopOptions.length > 0 &&
                                                item.shopOptions.map((shop, idx) => {
                                                    return (
                                                        <div className={`shop-item ${shop.isActive ? "active" : ""}`} key={idx}>
                                                            <input
                                                                type="checkbox"
                                                                checked={shop.isChecked}
                                                                onChange={(e) => {
                                                                    shop.isChecked = e.target.checked;
                                                                    setModel({ ...model });
                                                                }}
                                                                className="cursor-pointer"
                                                            />
                                                            <div
                                                                className="shop-name cursor-pointer"
                                                                onClick={(e) => {
                                                                    let md = { ...model };
                                                                    let platforms = md.multiPlatformModels;
                                                                    for (var pl of platforms) {
                                                                        pl.shopOptions.forEach((x) => {
                                                                            x.isActive = false;
                                                                        });
                                                                    }
                                                                    let platform = platforms[index];
                                                                    platform.isActive = true;
                                                                    let shopOptions = platform.shopOptions;
                                                                    let current = shopOptions[idx];
                                                                    current.isActive = true;
                                                                    setModel({ ...model });
                                                                }}
                                                            >
                                                                {shop.label}
                                                                {shop.pushingProductId > 0 && <div className="badge badge-orange">Đã đẩy</div>}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                );
                            })}
                    </section>

                    {/* Tùy chọn render hình và giá */}
                    {checkedShop && (
                        <section className="push_detail">
                            <h6>Tùy chọn render hình và giá</h6>
                            <div className="push_detail-body">
                                <section className="detail-info">
                                    <div className="push_detail-header">
                                        {checkedPlatform && <div className="icon">{getImage(checkedPlatform.platform)}</div>}
                                        <div className="detail-shop-name">{checkedShop.label}</div>
                                        <div className="float-right">
                                            <a
                                                className="text text-custom cursor-pointer"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                }}
                                            >
                                                Áp dụng cho tất cả shop khác
                                            </a>
                                        </div>
                                    </div>

                                    <div className="push_detail-image">
                                        <div className="push_detail-image-left"></div>
                                        <div className="push_detail-image-right">
                                            {checkedShop.manualPlatformProductId && (
                                                <div className="push_detail-cat">
                                                    <div className="cat-left">
                                                        <label htmlFor="" className="required">
                                                            Mã sản phẩm Platform (Thủ công)
                                                        </label>
                                                        <input type="text" className="form-control" readOnly value={checkedShop.manualPlatformProductId} />
                                                    </div>
                                                </div>
                                            )}
                                            <div className="push_detail-cat">
                                                <div className="cat-left">
                                                    <label htmlFor="" className="required">
                                                        Ngành hàng
                                                    </label>
                                                    <TFUSelect
                                                        placeholder="Chọn ngành hàng"
                                                        options={checkedShop.listCat}
                                                        value={checkedShop.opfCategoryId}
                                                        onChanged={(newValue) => {
                                                            let md = { ...model };
                                                            let platforms = md.multiPlatformModels;
                                                            let platform = platforms.find((x) => x.platform == checkedShop.platform);
                                                            let shopOptions = platform.shopOptions;
                                                            let current = shopOptions.find((x) => x.value == checkedShop.value);
                                                            current.opfCategoryId = newValue;
                                                            setModel({ ...model });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="push_detail-cat">
                                                <div className="cat-left">
                                                    <label htmlFor="" className="required">
                                                        Thương hiệu
                                                    </label>
                                                    <TFUSelect
                                                        placeholder="Chọn thương hiệu"
                                                        options={checkedShop.listBrand}
                                                        value={checkedShop.brandId}
                                                        onChanged={(newValue) => {
                                                            let md = { ...model };
                                                            let platforms = md.multiPlatformModels;
                                                            let platform = platforms.find((x) => x.platform == checkedShop.platform);
                                                            let shopOptions = platform.shopOptions;
                                                            let current = shopOptions.find((x) => x.value == checkedShop.value);
                                                            current.brandId = newValue;
                                                            setModel({ ...model });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="push_detail-photoshop">
                                                <label htmlFor="" className="required">
                                                    Chọn loại mô phỏng hình ảnh sản phẩm
                                                </label>
                                                <div className="list-file">
                                                    {checkedPlatform &&
                                                        checkedPlatform.photoshopFiles &&
                                                        checkedPlatform.photoshopFiles.length > 0 &&
                                                        checkedPlatform.photoshopFiles.map((item, index) => {
                                                            return (
                                                                <div
                                                                    className={`file-item ${item.id == checkedShop.photoshopId ? "active" : ""}`}
                                                                    key={index}
                                                                    onClick={async (e) => {
                                                                        let md = { ...model };
                                                                        let platforms = md.multiPlatformModels;
                                                                        let platform = platforms.find((x) => x.platform == checkedShop.platform);
                                                                        let shopOptions = platform.shopOptions;
                                                                        let current = shopOptions.find((x) => x.value == checkedShop.value);
                                                                        current.photoshopId = item.id;

                                                                        //lấy ra thông tin sản phẩm theo photoshopId
                                                                        if (md.packageType != PackageType.Case) {
                                                                            let pushModel = {
                                                                                designId: designId,
                                                                                photoshopId: item.id,
                                                                                platform: checkedShop.platform,
                                                                                shopId: checkedShop.value,
                                                                            };
                                                                            let psProducts = await _getPhotoshopProduct(pushModel);
                                                                            let first = psProducts && psProducts.length > 0 ? psProducts[0] : null;
                                                                            if (first) first.avatarChecked = true;
                                                                            current.photoshopProducts = psProducts;
                                                                        }

                                                                        setModel({ ...model });
                                                                    }}
                                                                >
                                                                    <div className="file-avatar">
                                                                        <img src={item.thumbnail} />
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                <section className="detail-product">
                                    <div className="push_detail-price-stock">
                                        <label htmlFor="" className="required">
                                            Giá sản phẩm
                                        </label>
                                        <div className="right-list-btn">
                                            <div
                                                className="show-cost cursor-pointer"
                                                onClick={(e) => {
                                                    setShowCostModal(true);
                                                }}
                                            >
                                                <span>
                                                    <img src={PercentageIcon} alt="" />
                                                    Tùy chọn các loại chi phí
                                                </span>
                                            </div>
                                        </div>
                                        <div className="section-table">
                                            <table className="table-wrapper table-bordered fixed-table">
                                                <thead>
                                                    <tr>
                                                        <th className="center col-product stick-left" colSpan={2} rowSpan={2}>
                                                            Dòng sản phẩm
                                                        </th>
                                                        <th className="center col-ranus-price" rowSpan={2}>
                                                            Giá bán Ranus
                                                        </th>
                                                        <th className="center col-tiktok-price" rowSpan={2}>
                                                            Giá bán trên Tiktokshop
                                                        </th>
                                                        <th className="center col-profit" rowSpan={2}>
                                                            Lợi nhuận gộp (Tạm tính)
                                                        </th>
                                                        <th className="center col-costs-group" colSpan={6}>
                                                            Tổng các chi phí
                                                        </th>
                                                        <th
                                                            className="center col-default stick-right"
                                                            rowSpan={2}
                                                            style={{
                                                                right: "59px",
                                                            }}
                                                        >
                                                            Mặc định
                                                        </th>
                                                        <th className="center col-visible stick-right" rowSpan={2}>
                                                            Hiển thị
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th className="center col-cost">Tổng chi phí sản xuất Ranus (Bao gồm thuế)</th>
                                                        <th className="center col-cost">Thuế của Partner</th>
                                                        <th className="center col-cost">Tổng chi phí Cố định Tiktokshop</th>
                                                        <th className="center col-cost">Tổng chi phí Voucher</th>
                                                        <th className="center col-cost">Tổng chi phí Marketing</th>
                                                        <th className="center col-cost">Tổng chi phí khác</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {checkedShop &&
                                                        checkedShop.photoshopProducts &&
                                                        checkedShop.photoshopProducts.length > 0 &&
                                                        checkedShop.photoshopProducts.map((ele, idx) => {
                                                            //chi phí cố định
                                                            if (!ele.listPartnerCostDiscount) ele.listPartnerCostDiscount = [];
                                                            const fixed = ele.listPartnerCostDiscount.find((x) => x.discountType == CostDiscountType.Fixed);
                                                            const voucher = ele.listPartnerCostDiscount.find((x) => x.discountType == CostDiscountType.Voucher);
                                                            const marketing = ele.listPartnerCostDiscount.find((x) => x.discountType == CostDiscountType.Marketing);
                                                            const other = ele.listPartnerCostDiscount.find((x) => x.discountType == CostDiscountType.Other);

                                                            return (
                                                                <tr key={idx} className={`${ele.partnerSellPrice == 0 ? "disabled" : ""}`}>
                                                                    <td className="avatar-row center stick-left">
                                                                        <img src={ele.appProductAvatar} className="img-row" alt="" />
                                                                    </td>
                                                                    <td
                                                                        className="row-name stick-left"
                                                                        style={{
                                                                            left: "94px",
                                                                            padding: "10px",
                                                                        }}
                                                                    >
                                                                        {ele.appProductName}
                                                                    </td>
                                                                    <td className="partner-sell-price">{Common.formatCurrency(ele.partnerSellPrice || 0)}</td>
                                                                    <td className="platform-sell-price">
                                                                        <TextNumber
                                                                            value={ele.sellPrice}
                                                                            name={"sellPrice" + idx}
                                                                            id={"sellPrice" + idx}
                                                                            onChanged={(name, value) => {
                                                                                let md = { ...model };
                                                                                let platforms = md.multiPlatformModels;
                                                                                let platform = platforms.find((x) => x.platform == checkedShop.platform);
                                                                                let shopOptions = platform.shopOptions;
                                                                                let current = shopOptions.find((x) => x.value == checkedShop.value);
                                                                                let psProducts = current.photoshopProducts;
                                                                                let currentProduct = psProducts[idx];
                                                                                currentProduct.sellPrice = +value;
                                                                                currentProduct.grossProfit = Math.ceil(currentProduct.sellPrice - currentProduct.total);
                                                                                currentProduct.grossProfitPercentage = Math.floor((currentProduct.grossProfit / currentProduct.sellPrice) * 100);
                                                                                setModel(md);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td className="center profit">
                                                                        <div className="input-group-revenue">
                                                                            <TextNumber
                                                                                className="revenue"
                                                                                value={ele.grossProfit}
                                                                                name={`grossProfit_${idx}`}
                                                                                id={`grossProfit_${idx}`}
                                                                                onChanged={(name, value) => {
                                                                                    let md = { ...model };
                                                                                    let platforms = md.multiPlatformModels;
                                                                                    let platform = platforms.find((x) => x.platform == checkedShop.platform);
                                                                                    let shopOptions = platform.shopOptions;
                                                                                    let current = shopOptions.find((x) => x.value == checkedShop.value);
                                                                                    let psProducts = current.photoshopProducts;
                                                                                    let currentProduct = psProducts[idx];
                                                                                    currentProduct.grossProfit = +value;
                                                                                    currentProduct.grossProfitPercentage = Math.floor((currentProduct.grossProfit / currentProduct.total) * 100);
                                                                                    currentProduct.sellPrice = Math.ceil(currentProduct.grossProfit + currentProduct.total);
                                                                                    setModel(md);
                                                                                }}
                                                                                suffix="đ"
                                                                            />
                                                                            <span>Hoặc</span>
                                                                            <TextNumber
                                                                                className="revenue-percentage"
                                                                                groupClassName="right"
                                                                                value={ele.grossProfitPercentage}
                                                                                name={`grossProfitPercentage_${idx}`}
                                                                                id={`grossProfitPercentage_${idx}`}
                                                                                onChanged={(name, value) => {
                                                                                    let md = { ...model };
                                                                                    let platforms = md.multiPlatformModels;
                                                                                    let platform = platforms.find((x) => x.platform == checkedShop.platform);
                                                                                    let shopOptions = platform.shopOptions;
                                                                                    let current = shopOptions.find((x) => x.value == checkedShop.value);
                                                                                    let psProducts = current.photoshopProducts;
                                                                                    let currentProduct = psProducts[idx];
                                                                                    currentProduct.grossProfitPercentage = +value;
                                                                                    currentProduct.grossProfit = Math.ceil((currentProduct.grossProfitPercentage / 100) * currentProduct.total);
                                                                                    currentProduct.sellPrice = Math.ceil(currentProduct.grossProfit + currentProduct.total);
                                                                                    setModel(md);
                                                                                }}
                                                                                suffix="%"
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                    <td style={{ padding: "10px" }}>{Common.formatCurrency(ele.productionCost)}</td>
                                                                    <td style={{ padding: "10px" }}>{Common.formatCurrency(ele.partnerTaxCost)}</td>
                                                                    <td style={{ padding: "10px" }}>{fixed ? Common.formatCurrency(fixed.discountTotal) : ""}</td>
                                                                    <td style={{ padding: "10px" }}>{voucher ? Common.formatCurrency(voucher.discountTotal) : ""}</td>
                                                                    <td style={{ padding: "10px" }}>{marketing ? Common.formatCurrency(marketing.discountTotal) : ""}</td>
                                                                    <td style={{ padding: "10px" }}>{other ? Common.formatCurrency(other.discountTotal) : ""}</td>
                                                                    <td
                                                                        className="center avatar-radio stick-right"
                                                                        style={{
                                                                            right: "59px",
                                                                        }}
                                                                    >
                                                                        <input
                                                                            type="radio"
                                                                            checked={ele.avatarChecked}
                                                                            onChange={(e) => {
                                                                                let md = { ...model };
                                                                                let platforms = md.multiPlatformModels;
                                                                                let platform = platforms.find((x) => x.platform == checkedShop.platform);
                                                                                let shopOptions = platform.shopOptions;
                                                                                let current = shopOptions.find((x) => x.value == checkedShop.value);
                                                                                let psProducts = current.photoshopProducts;
                                                                                psProducts.forEach((x) => (x.avatarChecked = false));
                                                                                let product = psProducts[idx];
                                                                                product.avatarChecked = true;
                                                                                setModel(md);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td className="stick-right center">
                                                                        <SwichToogle
                                                                            name={`visible_${idx}`}
                                                                            value={ele.checked}
                                                                            onCheckChanged={(name, value) => {
                                                                                let md = { ...model };
                                                                                let platforms = md.multiPlatformModels;
                                                                                let platform = platforms.find((x) => x.platform == checkedShop.platform);
                                                                                let shopOptions = platform.shopOptions;
                                                                                let current = shopOptions.find((x) => x.value == checkedShop.value);
                                                                                let psProducts = current.photoshopProducts;
                                                                                let currentProduct = psProducts[idx];

                                                                                //nếu sản phẩm đang được avatar checked thì không cho set false
                                                                                if (currentProduct.avatarChecked && !value) {
                                                                                    Notify(NOTIFY.INFO, NOTIFY.INFO, "Không thể bỏ chọn sản phẩm đang được chọn làm ảnh đại diện");
                                                                                    return;
                                                                                }
                                                                                currentProduct.checked = value;
                                                                                console.log("md :>> ", md);
                                                                                setModel(md);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </section>
                    )}

                    {/* Danh sách button xử lý */}
                    <section className="btn-bottom">
                        <div className="list-button">
                            <button
                                className="btn btn-secondary"
                                onClick={(e) => {
                                    history.push("/pushing-manage");
                                }}
                            >
                                Trở về
                            </button>
                            <button
                                className="btn btn-orange"
                                onClick={(e) => {
                                    setManualModal(true);
                                }}
                            >
                                Chọn sản phẩm thủ công
                            </button>
                            <button
                                className="btn btn-orange"
                                onClick={(e) => {
                                    createUpdatePushProduct();
                                }}
                            >
                                {checkedShop && checkedShop.manualPlatformProductId ? "Đồng bộ sản phẩm thủ công" : "Đẩy sản phẩm"}
                            </button>
                        </div>
                    </section>
                </section>
            </Wrapper>
            <PushTemplateModal show={showTemplateModal} onClose={() => setShowTemplateModal(false)} templateType={templateType} />
            <CostModal
                show={showCostModal}
                onClose={() => {
                    setShowCostModal(false);
                }}
                onSave={(cost) => {
                    if (cost) reApplyCost(cost);
                    setShowCostModal(false);
                }}
            />

            {checkedShop && (
                <PlatformProductModal
                    show={manualModal}
                    onClose={() => {
                        setManualModal(false);
                    }}
                    designId={designId}
                    onSave={(platformProductId) => {
                        let md = { ...model };
                        let platforms = md.multiPlatformModels;
                        let platform = platforms.find((x) => x.platform == checkedShop.platform);
                        let shopOptions = platform.shopOptions;
                        let current = shopOptions.find((x) => x.value == checkedShop.value);
                        current.manualPlatformProductId = platformProductId;
                        setModel(md);
                        setManualModal(false);
                    }}
                    shopId={checkedShop.value}
                    platform={checkedShop.platform}
                />
            )}
        </React.Fragment>
    );
}

export default PushingMultiDetail;

const Wrapper = styled.div`
    width: 90%;

    section.design_detail {
        flex: 1 1 0%;
        width: calc(100% - 294px);
        margin-left: 24px;
    }

    .cat-left input[type="text"] {
        width: 100%;
    }

    .input-group-revenue .input-group {
        display: flex;
        flex-wrap: nowrap;
        border: 1px solid rgb(229, 229, 229);
        border-radius: 6px 0 0 6px;
    }

    .input-group-revenue .input-group .input-group-append .input-group-text {
        background: transparent;
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: auto !important;
        height: auto;
        border: none;
    }

    input.revenue.form-control {
        border: none;
    }

    input.revenue-percentage.form-control {
        border: none;
    }

    .input-group.right {
        border-radius: 0 6px 6px 0;
    }
    .right-list-btn {
        margin-left: auto;
    }

    .push_detail-price-stock {
        display: flex;
        flex-wrap: wrap;
    }

    .section-table {
        margin-top: 16px;
    }

    .show-cost {
        display: flex;
        align-items: center;
        border-radius: 8px;
        border: 1px solid #ffe3c9;
        background: #fff5ec;
        padding: 6px 12px;
    }

    .show-cost span {
        color: #ff9027;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .show-cost span img {
        margin-right: 6px;
    }

    .list-button {
        margin: 0 0 0 auto;
    }

    button.btn.btn-secondary {
    }

    section.btn-bottom {
        margin: 12px 0;
        display: flex;
    }

    button.btn.btn-secondary {
        border-radius: 40px;
        border: 1px solid #e5e5e5;
        background: #f3f3f3;
        color: #000;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    button.btn {
        margin: 0 10px;
    }

    button.btn.btn-orange {
        border-radius: 40px;
        background: #ff9027;
        color: #fff;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .fixed-table {
        table-layout: fixed;
        width: 100%;
    }

    .col-product {
        width: 190px;
    }

    .col-ranus-price {
        width: 80px;
    }

    .col-tiktok-price {
        width: 110px;
    }

    .col-profit {
        width: 220px;
    }

    .col-costs-group {
        width: 840px;
    }

    .col-cost {
        width: 140px;
        padding: 10px;
    }

    .col-default,
    .col-visible {
        width: 60px;
        padding: 10px;
    }

    img.img-row {
        width: 80px;
        height: 80px;
        object-fit: contain;
        padding: 4px;
    }

    td.row-name {
        color: #303030;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    td.partner-sell-price {
        color: #303030;
        text-align: center;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .input-group-revenue {
        display: flex;
        align-items: center;
        height: 33px;
    }

    .input-group-revenue span {
        width: 50px !important;
    }

    td.platform-sell-price {
        padding: 5px;
    }

    td.center.profit {
        padding: 5px;
    }

    input.revenue {
        border-radius: 8px 0px 0px 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        padding: 5px 0 5px 5px;
    }

    .input-group-revenue span {
        border: 1px solid #e5e5e5;
        background: #444;
        color: white;
        height: 33px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 5px;
    }

    input.revenue-percentage {
        border-radius: 0px 8px 8px 0px;
        border: 1px solid #e5e5e5;
        background: #fff;
        padding: 5px 5px 5px 0;
    }

    .section-table {
        overflow: auto;
    }

    table.table.table-bordered {
        overflow: auto;
    }

    table.table-wrapper {
        overflow-x: auto;
    }

    .table-scrollable {
        overflow-x: auto;
        width: 100%;
    }

    section.detail-product {
        margin: 12px 0;
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        padding: 12px;
    }

    section.push_detail {
        width: calc(100% - 270px - 24px);
        margin-left: 24px;
    }

    .push_detail h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 100% */
    }

    section.detail-info {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
    }

    .push_detail-header {
        padding: 16px;
        display: flex;
        align-items: center;
        border: 1px solid #f3f3f3;
    }

    .float-right {
        margin-left: auto;
        border-radius: 8px;
        border: 1px solid #ffe3c9;
        background: #fff5ec;
        padding: 8px;
    }

    .push_detail-header .icon {
        height: 23px;
        width: auto;
    }

    .push_detail-header .icon img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .detail-shop-name {
        color: #444;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-left: 12px;
    }

    .float-right a {
        color: #ff9027 !important;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .push_detail-image {
        padding: 16px;
        display: flex;
    }

    .push_detail-image-left {
        width: 30%;
    }

    .push_detail-image-right {
        flex: 1;
        margin-left: 24px;
    }

    .push_detail-cat {
        margin: 10px 0;
    }

    .list-file {
        display: flex;
        flex-wrap: wrap;
    }

    .file-item {
        width: 85px;
        height: 85px;
        border-radius: 10px;
        overflow: hidden;
        margin: 5px 5px 5px 0;
    }

    .file-item.active {
        border-radius: 8px;
        border: 1px solid #ff9027;
        background:
            linear-gradient(0deg, rgba(255, 144, 39, 0.3) 0%, rgba(255, 144, 39, 0.3) 100%),
            url(<path-to-image>) lightgray 50% / cover no-repeat;
    }

    .file-item.active .file-avatar {
        opacity: 0.5;
    }

    section.push_product {
        display: flex;
        flex-wrap: wrap;
        margin: 12px 0;
    }

    section.btn-bottom {
        width: 100%;
    }

    section.push_shop {
        width: 270px;
    }

    section.push_detail {
        flex: 1;
    }

    .push_shop h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 100% */
    }

    .shop-platform {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        padding: 16px;
    }

    .heading .icon {
        height: 20px;
    }

    .shop-item {
        display: flex;
        align-items: center;
        margin: 10px 0;
        border-radius: 8px;
        padding: 8px;
    }

    .shop-name {
        color: #444;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 153.846% */
        margin-left: 6px;
        display: flex;
        align-items: center;

        .badge {
            margin-left: 6px;
        }
    }

    .stick-left {
        position: sticky;
        left: 0;
        background: rgb(255, 255, 255);
        z-index: 100;
    }

    .stick-right {
        position: sticky;
        right: 0;
        background: rgb(255, 255, 255);
        z-index: 100;
    }

    .shop-item.active {
        border-radius: 8px;
        background: #fff5ec;
    }

    .file-avatar {
        width: 85px;
        height: 85px;
        aspect-ratio: 1/1;
    }

    .file-avatar img {
        width: 100%;
        height: 100%;
    }
    /* thông tin sản phẩm */
    section.product_overview {
        margin: 12px 0;
    }

    section.product_info {
        margin: 12px 0;
    }

    section.product_info {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        padding: 20px 24px;
    }

    .info-row {
        display: flex;
        margin: 16px 0;
    }

    .info-row label.required {
        width: 15%;
    }

    .info-input {
        flex: 1;
    }

    .template {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    }

    .list-tag {
        display: flex;
    }

    .open-template {
        margin-left: auto;
    }

    .tag {
        color: #ff9027;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        margin: 0 10px;
    }

    .tag:first-child {
        margin-left: 0;
    }

    .icon {
        display: flex;
    }

    .input-area input[type="text"] {
        border: none;
        flex: 1;
    }

    .input-area {
        display: flex;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        align-items: center;
        padding: 9px 17px;
    }

    .input-area textarea {
        width: 100%;
        border: none;
    }

    /* avatar */
    .avatar {
        width: 120px;
        height: 120px;
    }

    .avatar img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    section.product_overview {
        display: flex;
        border-radius: 12px;
        background: #fff;
        padding: 24px;
    }

    .overview-section {
        margin-left: 36px;
    }

    .overview-title {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .overview-color {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 12px 0;
    }
`;

const OpenTemplateIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H2V3Z"
                stroke="#FF9027"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H22V3Z"
                stroke="#FF9027"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
